import React from 'react';
import "./_skeleton.scss";

export default function SkeletonRectangle() {
    return (
        <div className="skeleton skeleton-rectangle" />
    );
};
